document.addEventListener("DOMContentLoaded", function () {
  const toggleSelector = "[data-accessibility-toggle]";
  const body = document.body;
  let isEnabled = false;
  try {
    isEnabled = localStorage.getItem("accessibilityContrast") === "enabled";
  } catch {
    // The controls still work when browser storage is unavailable.
  }

  const syncToggles = () => {
    body.classList.toggle("accessibility-contrast", isEnabled);
    document.querySelectorAll(toggleSelector).forEach((toggle) => {
      toggle.checked = isEnabled;
      toggle.setAttribute("aria-checked", String(isEnabled));
    });
  };

  syncToggles();

  document.addEventListener("change", (event) => {
    if (!event.target.matches(toggleSelector)) return;
    isEnabled = event.target.checked;
    syncToggles();
    try {
      localStorage.setItem("accessibilityContrast", isEnabled ? "enabled" : "disabled");
    } catch {
      // Keep the chosen state for this page even if persistence is blocked.
    }
  });

  document.addEventListener("shopify:section:load", syncToggles);

  function applyVideoAccessibility() {
    const allVideos = Array.from(document.querySelectorAll("video"));

    allVideos.forEach((video) => {
      if (video.hasAttribute("autoplay") && !video.dataset.hadAutoplay) {
        video.dataset.hadAutoplay = "true";
      }

      video.removeAttribute("autoplay");
      video.setAttribute("preload", "none");

      try {
        video.pause();
        video.currentTime = 0;
      } catch (err) {
        console.warn("err", err);
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              video
                .play()
                .catch((err) => console.warn("Error al reproducir:", err));
              setTimeout(() => {
                video.pause();
              }, 5000);
            } else {
              video.pause();
            }
          });
        },
        {
          threshold: 0.5,
        }
      );
      observer.observe(video);
    });
  }

  applyVideoAccessibility();
});

document.addEventListener("DOMContentLoaded", () => {
  const chatTriggers = document.querySelectorAll(".open-chat-zd");
  if (!chatTriggers.length) return;

  const zendeskSrc =
    window.__zendeskSupportSrc ||
    "https://static.zdassets.com/ekr/snippet.js?key=a9746106-3956-4daf-85e3-51fa2db6458f";

  function isZendeskMessengerOpen() {
    return Array.from(document.querySelectorAll("iframe")).some((frame) => {
      const title = (frame.getAttribute("title") || "").toLowerCase();
      return title.includes("messaging window") && !title.includes("button to launch");
    });
  }

  function placeZendeskLauncher(frame) {
    const shortcutsPanel = document.querySelector(".accessibility-shortcuts");
    const launcherContainer = frame.parentElement;
    if (
      shortcutsPanel &&
      launcherContainer &&
      launcherContainer.parentElement === document.body &&
      shortcutsPanel.nextElementSibling !== launcherContainer
    ) {
      document.body.insertBefore(launcherContainer, shortcutsPanel.nextElementSibling);
    }
  }

  function activateZendeskLauncher() {
    return Array.from(document.querySelectorAll("iframe")).some((frame) => {
      const title = (frame.getAttribute("title") || "").toLowerCase();
      if (!title.includes("button to launch") && !title.includes("messaging")) return false;

      try {
        placeZendeskLauncher(frame);
        const frameDocument = frame.contentDocument || frame.contentWindow?.document;
        const launcherButton = frameDocument?.querySelector("button, [role='button'], [tabindex]");
        if (!launcherButton) return false;

        launcherButton.click();
        launcherButton.focus?.();
        frame.focus?.();
        return true;
      } catch (err) {
        frame.focus?.();
        return false;
      }
    });
  }

  function callZendeskMessenger() {
    if (isZendeskMessengerOpen()) return true;
    if (typeof window.__openZendeskSupportMessenger === "function") {
      return window.__openZendeskSupportMessenger();
    }
    if (typeof window.zE !== "function") return activateZendeskLauncher();

    try {
      window.zE("messenger", "show");
      window.zE("messenger", "open");
    } catch (err) {
      return activateZendeskLauncher();
    }
    return isZendeskMessengerOpen() || activateZendeskLauncher();
  }

  function loadZendeskScript() {
    if (document.getElementById("ze-snippet")) return;

    window.zE =
      window.zE ||
      function () {
        (window.zE.q = window.zE.q || []).push(arguments);
      };

    const script = document.createElement("script");
    script.id = "ze-snippet";
    script.src = zendeskSrc;
    script.async = true;
    script.dataset.performanceGateBypass = "true";
    script.addEventListener("load", () => {
      window.__zendeskSupportReady = true;
      retryOpenZendesk();
    });
    document.body.appendChild(script);
  }

  function retryOpenZendesk(attemptsRemaining = 120) {
    if (callZendeskMessenger()) {
      window.__openSupportChatRequested = false;
      return;
    }

    if (attemptsRemaining > 0) {
      window.setTimeout(() => retryOpenZendesk(attemptsRemaining - 1), 300);
    }
  }

  function openSupportChat(event) {
    event?.preventDefault();
    window.__openSupportChatRequested = true;

    if (typeof window.openSupportChat === "function") {
      window.openSupportChat(event);
    }

    loadZendeskScript();
    retryOpenZendesk();
  }

  function focusZendeskChat() {
    setTimeout(() => {
      const textarea = document.querySelector("#composer-input");
      if (textarea) {
        textarea.focus();
      } else {
        setTimeout(() => {
          const retryTextarea = document.querySelector("#composer-input");
          if (retryTextarea) retryTextarea.focus();
        }, 800);
      }
    }, 600);
  }

  chatTriggers.forEach((trigger) => {
    if (!["BUTTON", "A"].includes(trigger.tagName)) {
      trigger.setAttribute("tabindex", "0");
      trigger.setAttribute("role", "button");
    }
    trigger.addEventListener("click", (e) => {
      openSupportChat(e);
      focusZendeskChat();
    });
    trigger.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        openSupportChat(e);
        focusZendeskChat();
      }
    });
  });
});
